export default __webpack_public_path__ + "static/media/Gallery_black.8489074e.svg";